import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useShare } from '../../data/share';
import JobListingShare from '../../components/socials/JobListingDetails';

const SocialPage = () => {
  const params = useParams();
  const [shareId, setShareId] = useState(params.shareId || "");
  const{ data: share } = useShare(params.shareId || "");

  return (
    <div className="bg-white w-full">
      <div className="mt-36">
      {share && share.type === "job" && <JobListingShare id={share.typeId} share={share} />}
      </div>
    </div>
  );
};

export default SocialPage;
